<template>
  <v-dialog
    :value="opened"
    width="800"
    scrollable
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @keydown.esc="$emit('update:opened', false)"
  >
    <v-card>
      <v-card-title class="title pb-0">
        Audit Trail
        <v-spacer />

        <v-btn
          fab
          small
          flat
          class="white error--text text-capitalize ma-0"
          @click="$emit('update:opened', false)"
        >
          <v-icon size="25"> clear </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="logs"
          :pagination.sync="pagination"
          :loading="loading"
          hide-actions
          class="table-container"
        >
          <template slot="items" slot-scope="props">
            <tr :key="props.index" slot="header" valign="top">
              <td class="text-xs-left">
                {{ props.item.title }}
              </td>
              <td class="text-xs-left">
                <event-box
                  :eventType="props.item.event_type"
                  :eventPayload="props.item.event_payload"
                />
              </td>
              <td class="text-xs-left">
                {{
                  moment(props.item.created_at).format('MMMM DD, YYYY hh:mm A')
                }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/api';
import moment from 'moment';
import EventBox from '@/components/returns/EventBox';

export default {
  components: {
    EventBox,
  },

  props: {
    opened: {
      type: Boolean,
      required: true,
    },

    taxReturn: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      logs: [],
      loading: false,
      headers: [
        {
          text: 'Event',
          align: 'left',
          sortable: false,
          value: 'title',
          width: '30%',
        },
        {
          text: 'Description',
          align: 'left',
          sortable: false,
          value: 'event_payload',
          width: '40%',
        },
        {
          text: 'Date & Time',
          value: 'created_at',
          align: 'left',
          sortable: true,
          width: '30%',
        },
      ],
      pagination: {
        sortBy: 'created_at',
        descending: false,
        rowsPerPage: -1,
      },
    };
  },

  methods: {
    moment,

    async getActivityLogs() {
      try {
        this.loading = true;

        const response = await API.taxReturn.getActivityLogs({
          id: this.taxReturn.id,
          companyId: this.taxReturn.company_id,
        });

        this.logs = response.data;
      } catch (error) {
        console.error(error);
        Sentry.captureException(error);
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    async opened(val) {
      if (val) {
        await this.getActivityLogs();
      }
    },
  },

  async created() {
    // This is needed when the dialog is opened immediately after the component is created
    await this.getActivityLogs();
  },
};
</script>

<style scoped>
.title {
  font-weight: bold;
}

/* Specify a more detailed CSS scope here to prevent its override in the production */
.table-container table.v-table tbody tr td {
  padding: 12px 6px;
}
</style>
